// Link público de assinatura do contrato do MOTORISTA (Gestão de Frota,
// pedido 2026-10-26) — mesmas telas do contrato do cliente. Pública pelo
// mesmo prefixo "/contrato/assinar/" (isPublicStaticRoute em __root.tsx).
import { createFileRoute } from "@tanstack/react-router";
import { ContractSigningWizard } from "@/components/contract-signing-wizard";
import { fleetContractSigningService } from "@/services/gpsdrive-contract-signing.service";

export const Route = createFileRoute("/contrato/assinar/m/$token")({
  head: () => ({ meta: [{ title: "Assinatura de Contrato — GPS Drive" }] }),
  component: FleetContractSigningPage,
});

function FleetContractSigningPage() {
  const { token } = Route.useParams();
  return <ContractSigningWizard token={token} service={fleetContractSigningService} />;
}
